import React, { useState } from 'react';
import { Icon, Grid } from '@printdeal/ui-library';
import { FormattedMessage, useIntl } from 'react-intl';
import { ReviewReply } from '../../../../helpers/reviewHelper';
import { TimeAgo } from './TimeAgo';
import { dispatchDataLayerEntry } from '../../../../helpers/dataLayerHelpers/productDataLayerHelper';

interface Props {
  replies: ReviewReply[];
  contentfulId: string;
}

export const ReviewReplies = ({ replies, contentfulId }: Props) => {
  const intl = useIntl();
  const [toggleReplies, setToggleReplies] = useState(false);
  const hideRepliesText = intl.formatMessage({ id: 'productDetail.reviews.hide', defaultMessage: 'Hide' });
  const viewRepliesText = intl.formatMessage({ id: 'productDetail.reviews.view', defaultMessage: 'View' });

  const handleToggleReplies = () => {
    setToggleReplies(!toggleReplies);

    // GA event
    dispatchDataLayerEntry(
      'Toggle review replies',
      'click',
      { contentfulId },
    );
  };

  return (
    <Grid.Item className="pd-ml-3">
      <div className="pd-flex pd-items-center pd-gap-2">
        <button
          type="button"
          onClick={handleToggleReplies}
          className="pd-flex pd-items-center pd-justify-center pd-gap-1 pd-text-sm pd-font-semibold pd-text-black hover:pd-text-primary-500"
          aria-label="Toggle replies"
        >
          <Icon icon="chat" size="sm" className="pd-text-dim-500" />
          <span className="pd-px-1 pd-pb-1 pd-text-sm pd-font-semibold">
            <FormattedMessage
              id="productDetail.reviews.replies"
              defaultMessage="{toggleReplies} {plural, plural, one {comment} other {comments}} from our co-worker{plural, plural, one {} other {s}}"
              values={{
                plural: replies.length,
                toggleReplies: toggleReplies ? hideRepliesText : viewRepliesText,
              }}
            />
          </span>
          <Icon
            icon={toggleReplies ? 'chevron-up' : 'chevron-down'}
            className="pd-text-dim-500"
            size="sm"
          />
        </button>
      </div>
      {toggleReplies && (
        <div>
          {replies?.map((reply) => (
            <div key={reply.date_created}>
              <p className="pd-my-2">
                {reply.author.name} {' '}
                <TimeAgo date={reply.date_created} />
              </p>
              <p className="pd-whitespace-pre-wrap">{reply.comments}</p>
              <p>By {reply.author.name}</p>
            </div>
          ))}
        </div>
      )}
    </Grid.Item>
  );
};
